import React, { PureComponent } from 'react';
import styled from 'styled-components';

import BannerLayout from '../../layouts/banner';

import ConductResearchImage from '../../../../../containers/assets/onboarding-conduct-research.png';

const FormulaBlock = styled.div`
  background: #6FD1D9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  margin-top: 12px;
`;

const FormulaLeftPart = styled.div`
  background: #2A4169;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  text-align: center;
  margin-right: 12px;
  min-height: 120px;
  display: flex;
  align-items: center;
`;

const EqualitySign = styled.div`
  width: 16px;
  height: 7px;
  position: relative;

  &:before, &:after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 1.5px;
    background: rgba(0, 27, 59, 0.94);
    border-radius: 100px;
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }
`;

const Image = styled.div`
  margin-left: 5px;
  position: relative;
  padding: 0 12px;

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 8px;
    height: 43px;
    left: 0;
    right: 0;
    border-radius: 4px;
    border: 2px solid #2A4169;
  }
`;

const FormulaRightPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 212px;
  margin-left: 12px;
  text-align: center;
  color: rgba(0, 27, 59, 0.94);
`;

const FormulaDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(0, 27, 59, 0.94);
  margin: 12px 0;
`;

class NewScoringMetrics extends PureComponent {

  render() {
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="New scoring metrics"
        alertText="New Scoring Metrics: Return on Investments"
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>Metrics change in round 3. New metrics such as ROE and ROA that use net profits to measure the return on an investment (ROI) are introduced. </p>
        )}
        visual={(
          <FormulaBlock>
            <FormulaLeftPart>
              <p>ROI Metrics</p>
            </FormulaLeftPart>
            <EqualitySign></EqualitySign>
            <FormulaRightPart>
              <p>Income Statements</p>
              <FormulaDivider></FormulaDivider>
              <p>Balance Sheet</p>
            </FormulaRightPart>
            <Image>
              <img src={ConductResearchImage} alt=""></img>
            </Image>
          </FormulaBlock>
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default NewScoringMetrics;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/new-scoring-metrics.js